import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		MenuCheckedItem: 0,
		navChangeChecked: 999,
		Currentposition: [{
			path: '/',
			name: '首页'
		}, ],
		guid: '',
		seo: {
			title: '',
			keywords: '',
			description: ''
		},
		DesceOrder:0, //律所动态/党建专区 文章是否降序排列
		NavList:'',//导航栏内容
		partyOrder:false, //党建动态  排序
		dynamicOrder:false, // 律所动态  排序 
		caseOrder:false, //经典案例  排序
		chenkedPinYin:'',
	
	},
	mutations: {

	},
	actions: {},
	modules: { },



})
